import { render, staticRenderFns } from "./EntityForm.vue?vue&type=template&id=1f687ca2"
import script from "./EntityForm.vue?vue&type=script&lang=js"
export * from "./EntityForm.vue?vue&type=script&lang=js"
import style0 from "./EntityForm.vue?vue&type=style&index=0&id=1f687ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports